import React from 'react';
import SubmitClaimWizard from './SubmitClaimWizard';

const JoinSubmitted = () => {
  return <SubmitClaimWizard initialStep={5} />;
};

export default JoinSubmitted;
